// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"df227c47","455":"2030669e","977":"0d141687"}[chunkId] + ".chunk.js";
};